import { render, staticRenderFns } from "./NewProfile.vue?vue&type=template&id=5134eced&scoped=true"
import script from "./NewProfile.vue?vue&type=script&lang=js"
export * from "./NewProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5134eced",
  null
  
)

export default component.exports